import {
  ActivityCancelSignupScreenDocument,
  ActivitySignupScreenDocument,
  ActivitySubscription,
  ScreenProfile,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const signup = async (
  profile: ScreenProfile,
  subscription: ActivitySubscription
) => {
  const response = await apolloClient.mutate({
    mutation: ActivitySignupScreenDocument,
    variables: {
      profile,
      subscription,
    },
    errorPolicy: 'all',
  });

  if (response.data?.activitySignupScreen?.success) {
    return response.data;
  }

  throw new SentryGraphQLError(`api.activities.signup`, response);
};

const cancelSignup = async (
  profile: ScreenProfile,
  subscription: ActivitySubscription
) => {
  const response = await apolloClient.mutate({
    mutation: ActivityCancelSignupScreenDocument,
    variables: {
      profile,
      subscription,
    },
    errorPolicy: 'all',
  });

  if (response.data?.activityCancelSignupScreen?.success) {
    return response.data;
  }

  throw new SentryGraphQLError(`api.activities.cancelSignup`, response);
};

export default {
  signup,
  cancelSignup,
};
